export default __webpack_public_path__ + "static/rsz_2pomerania_logo-90768f0d7a49c89f0d5ea15324194074.png";